"use client";
import { resolveClassNames } from "../use-styles/get-class-name/resolve-class-names/resolve-class-names.mjs";
import { resolveStyles } from "../use-styles/get-style/resolve-styles/resolve-styles.mjs";
import { useMantineTheme } from "../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs";
//#region packages/@mantine/core/src/core/styles-api/use-resolved-styles-api/use-resolved-styles-api.ts
function useResolvedStylesApi({ classNames, styles, props, stylesCtx }) {
	const theme = useMantineTheme();
	return {
		resolvedClassNames: classNames === void 0 ? void 0 : resolveClassNames({
			theme,
			classNames,
			props,
			stylesCtx: stylesCtx || void 0
		}),
		resolvedStyles: styles === void 0 ? void 0 : resolveStyles({
			theme,
			styles,
			props,
			stylesCtx: stylesCtx || void 0
		})
	};
}
//#endregion
export { useResolvedStylesApi };

//# sourceMappingURL=use-resolved-styles-api.mjs.map